/**
 * PDP Swiper Functionality
 * Handles product detail page image slider with trackpad/mousewheel support
 */

document.addEventListener('DOMContentLoaded', function () {
  // Initialize Product Gallery Swiper only on mobile devices
  function initMobileSwiper() {
    if (window.innerWidth <= 768) {
      const productSwiper = document.querySelector('.mySwiper.mobile-slider-only');
      console.log('Swiper element found:', productSwiper);

      if (productSwiper) {
        // Remove debugger and ensure proper initialization
        productSwiper.slidesPerView = 1.1;
        productSwiper.spaceBetween = 14;
        productSwiper.centeredSlides = false;
        productSwiper.loop = true;

        // ✅ Enable trackpad/mousewheel scroll
        productSwiper.mousewheel = {
          forceToAxis: true,  // restricts to horizontal scroll only
          releaseOnEdges: true, // allows normal page scroll at ends
          sensitivity: 0.1, // reduced sensitivity for one slide at a time
          thresholdDelta: 50, // minimum scroll distance required
          thresholdTime: 500, // minimum time between scroll events
        };

        // Initialize if not already initialized
        if (!productSwiper.swiper) {
          productSwiper.initialize();
        } else {
          // If already initialized, update the mousewheel settings
          productSwiper.swiper.mousewheel.enable();
        }

        console.log('Swiper initialized with trackpad/mousewheel support');
      }
    }
  }

  // Initialize on load
  initMobileSwiper();

  // Re-initialize on resize
  window.addEventListener('resize', function() {
    setTimeout(initMobileSwiper, 100);
  });

  // Handle popup functionality
  const image_popup = document.getElementById("image-popup");
  const closeButton = document.getElementById("close-popup");

  // Open popup when clicking on product images
  const slides = document.querySelectorAll('.mySwiper swiper-slide');
  slides.forEach(function(slide) {
    slide.addEventListener('click', function() {
      if (image_popup) {
        image_popup.classList.remove("hidden-pop");
      }
    });
  });

  // Close popup functionality
  if (closeButton && image_popup) {
    closeButton.addEventListener("click", function () {
      image_popup.classList.add("hidden-pop");
    });
  }

  // Close popup when clicking outside
  if (image_popup) {
    image_popup.addEventListener('click', function(e) {
      if (e.target === image_popup) {
        image_popup.classList.add("hidden-pop");
      }
    });
  }
});